export default __webpack_public_path__ + "static/media/blockUserRed.341382ae.svg";